var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEhWesternSahara(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3445_26542",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0575,
    cy: 21.7841,
    r: 21.7841,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3445_26542)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    y: 43.5681,
    width: 13.3125,
    height: 43.5682,
    transform: "rotate(-90 0.273438 43.5681)",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    y: 30.2556,
    width: 16.9432,
    height: 43.5682,
    transform: "rotate(-90 0.273438 30.2556)",
    fill: "#F5F7F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.273438,
    y: 13.3125,
    width: 13.3125,
    height: 43.5682,
    transform: "rotate(-90 0.273438 13.3125)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.273438 5.44604V38.1222H1.48366L8.74503 32.6762L23.2678 21.7841L8.74503 10.8921L1.48366 5.44604H0.273438Z",
    fill: "#D80027"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEhWesternSahara);
export default __webpack_public_path__ + "static/media/EH Western Sahara.5694143a438ed4a335203d115acae8d0.svg";
export { ForwardRef as ReactComponent };